import { WorkflowsByLabelResponse } from '@/types/composer-dashboard';
import { apiRequest } from '@/utils/api-request';

export const getWorkflowsByLabel = async (
  orgId: string,
): Promise<WorkflowsByLabelResponse> => {
  const response = await apiRequest<WorkflowsByLabelResponse>({
    url: `/api/v1/orgs/${orgId}/admin/metrics/workflows-by-label`,
    method: 'GET',
    target: 'workflow',
  });

  if (response.detail) {
    throw new Error(response.detail);
  }

  if (!response.data) {
    throw new Error('Failed to fetch workflows by label metrics');
  }

  return response.data;
};
